// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-table {
  min-width: 500px;
  overflow: unset;
}

mat-cell:last-of-type {
  padding-right: 0;
}

mat-cell {
  flex: 0 1 auto !important;
  white-space: normal !important;
  padding-right: 0;
  max-width: 200px;
}

.image-size {
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 100%;
  max-height: 200px;
}

.mat-column-label {
  font-weight: 500 !important;
  align-self: stretch;
  min-width: 140px;
}

.column-1 {
  width: 80%;
}

.column-2 {
  width: 40%;
}

.column-3 {
  width: 26.67%;
}

.column-4 {
  width: 20%;
}

.column-5 {
  width: 16%;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/article/components/article-compare/article-compare.component.scss"],"names":[],"mappings":"AAIA;EACI,gBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,yBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ","sourcesContent":["@use '@angular/material' as mat;\r\n@import '@angular/material/theming';\r\n$config: mat.define-legacy-typography-config();\r\n\r\nmat-table {\r\n    min-width: 500px;\r\n    overflow: unset;\r\n}\r\n\r\nmat-cell:last-of-type {\r\n    padding-right: 0;\r\n}\r\n\r\nmat-cell {\r\n    flex: 0 1 auto !important;\r\n    //width: 16.67% !important;\r\n    white-space: normal !important;\r\n    padding-right: 0;\r\n    max-width: 200px;\r\n}\r\n\r\n.image-size {\r\n    flex-grow: 1;\r\n    flex-shrink: 1;\r\n    max-width: 100%;\r\n    max-height: 200px;\r\n}\r\n\r\n.mat-column-label {\r\n    font-weight: mat.font-weight($config, button) !important;\r\n    align-self: stretch;\r\n    min-width: 140px;\r\n}\r\n\r\n.column-1 {\r\n    width: 80%;\r\n}\r\n\r\n.column-2 {\r\n    width: 40%;\r\n}\r\n\r\n.column-3 {\r\n    width: 26.67%;\r\n}\r\n\r\n.column-4 {\r\n    width: 20%;\r\n}\r\n\r\n.column-5 {\r\n    width: 16%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
